export { NavLink } from './NavLink';
export type {
  NavLinkAnchorProps,
  NavLinkNativeProps,
  NavLinkWrapProps,
} from './NavLink';
